import axios from '../lib/axios';

export default {
  login: async (email, password, role) => {
    // Mock implementation
    return Promise.resolve({
      data: {
        user: { email, role, name: 'Test User' },
        token: 'mock-token'
      }
    });
  },
  
  register: async (userData) => {
    // Mock implementation
    return Promise.resolve({
      data: {
        user: userData,
        token: 'mock-token'
      }
    });
  },
  
  getCurrentUser: async () => {
    // Mock implementation
    return Promise.resolve({
      data: { email: 'test@example.com', role: 'buyer', name: 'Test User' }
    });
  }
};